// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__KpeG5","unit":"Auth_unit__N+Qmr","unit--inputs":"Auth_unit--inputs__l7-2u","text":"Auth_text__E7b2N"};